import React, { lazy } from 'react';
const Orders = lazy(() => import('../pages/order/Order'));
const routes = [{
    path: 'search-order',
    element: <Orders />,
}];

export default routes;
